import styled from 'styled-components/macro';
import { Form } from 'formik';

export const LoginDiv = styled.div`
	position: relative;
	width: 90%;
	max-width: 820px;
	min-height: 95vh;
	margin: 0 auto;
`;

export const LoginForm = styled(Form)`
	max-width: 28em;
	width: 100%;
	margin-top: 4em;
	${({ theme }) => theme.mediaQueries.mobile} {
		margin-top: 1.5em;
	}
`;
